import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import { injectIntl } from 'react-intl';
import useVersionCheck from '../../hooks/useVersionCheck';

/**
 * Displays a persistent snackbar when a new version of the app is available.
 * Clicking the button reloads the page so the browser fetches the latest assets.
 */
const AppUpdateNotification = ({ intl }) => {
  const { updateAvailable, applyUpdate } = useVersionCheck();

  const action = (
    <Button
      color="secondary"
      size="small"
      onClick={applyUpdate}
    >
      {intl.formatMessage({ id: 'appUpdate.action' })}
    </Button>
  );

  return (
    <Snackbar
      style={{ zIndex: 9999999999 }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={updateAvailable}
      message={intl.formatMessage({ id: 'appUpdate.message' })}
      action={action}
    />
  );
};

AppUpdateNotification.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(AppUpdateNotification);
